var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"cancellation-agreement",attrs:{"src":"https://protocol.xd.cn/logout-agreement.html","title":"心动账号注销协议","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }